/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { CloseIcon } from '../PRIVATE_ThemedIcons/CloseIcon';
import { IconButton } from '../UNSAFE_IconButton';
import { useTranslationBundle } from '../hooks/UNSAFE_useTranslationBundle';
import { BundleType } from '../resources/nls/bundle';
import { classNames } from '../utils/UNSAFE_classNames';
import { MessageVariant } from './Message.types';
import { messageCloseButtonStyles } from './themes/MessageStyles.css';

/**
 * Props for the MessageCloseButton component
 */
type Props = {
  /**
   * The callback function to be called when the close icon is clicked
   */
  onAction: (event?: Event) => void;

  /**
   * Style variant
   */
  variant?: MessageVariant;
};

/**
 * A Component for rendering the message close button
 */
function MessageCloseButton({ onAction, variant = 'banner' }: Props) {
  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');
  const renderedButton = (
    <IconButton
      aria-label={translations.message_close()}
      size="sm"
      variant="borderless"
      onAction={onAction}>
      <CloseIcon />
    </IconButton>
  );
  // TODO:  Refactor to utilize useComponentTheme and multiVariantStyles.
  const classes = classNames([messageCloseButtonStyles.base, messageCloseButtonStyles[variant]]);

  // Otherwise, render the close icon
  return (
    <div class={classes} data-oj-message-close-button="">
      {renderedButton}
    </div>
  );
}

export { MessageCloseButton };
